import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chat",
  "use": "icon-chat-usage",
  "viewBox": "0 0 18 17",
  "content": "<symbol viewBox=\"0 0 18 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-chat\"><path d=\"M14.698.958c.187 0 .28.107.28.32v8.556c0 .24-.093.36-.28.36H7.221l-3.598 3.558v-3.558H1.344c-.08 0-.166-.04-.26-.12-.093-.08-.14-.16-.14-.24V1.278c0-.213.134-.32.4-.32h13.354zm2.559 2.519c.213 0 .32.12.32.36v8.556c0 .24-.107.36-.32.36h-2.28v3.558l-3.597-3.558H6.182l1.56-1.56h7.236c.666 0 1-.346 1-1.04V3.478h1.279z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol